/* SMELU · Upsell-Karte
   1. Farbe folgt der Variantenwahl des Hauptprodukts
   2. Der Haken haengt eine zweite Position an den Warenkorb          */
(function () {
  var card = document.querySelector('[data-smelu-ds]');

  /* ---------- 1. Farbkopplung ---------- */
  if (card) {
    var map = {};
    (card.getAttribute('data-ds-map') || '').split(';').forEach(function (rec) {
      if (!rec) return;
      var f = rec.split('~');
      if (f.length >= 3 && f[0]) map[f[0]] = { id: f[1], price: f[2], img: f[3] || '' };
    });

    var keyOf = function (txt) {
      var s = (txt || '').toLowerCase();
      if (s.indexOf('creme') > -1 || s.indexOf('cream') > -1) return 'creme';
      if (s.indexOf('schwarz') > -1 || s.indexOf('black') > -1) return 'schwarz';
      return '';
    };

    var apply = function (key) {
      var e = map[key];
      if (!e) return;
      var cb = card.querySelector('[data-smelu-ds-extra]');
      if (cb) cb.value = e.id;
      var pr = card.querySelector('[data-smelu-ds-price]');
      if (pr && e.price) pr.textContent = e.price;
      var im = card.querySelector('[data-smelu-ds-img]');
      if (im && e.img) im.src = e.img;
    };

    /* Primaer: Klick auf ein Farbfeld. Die Felder tragen die Farbe als
       data-value, das ist zuverlaessiger als auf eine Textaenderung zu warten. */
    document.addEventListener('click', function (ev) {
      var sw = ev.target.closest ? ev.target.closest('[data-pdp-swatch]') : null;
      if (!sw) return;
      var k = keyOf(sw.getAttribute('data-value') || sw.textContent);
      if (k) setTimeout(function () { apply(k); }, 0);
    });

    /* Zusaetzlich: die Farbzeile beobachten, falls die Variante auf anderem
       Weg wechselt, etwa ueber einen Link mit ?variant= */
    var labels = document.querySelectorAll('[data-pdp-option-value-0],[data-pdp-option-value-1],[data-pdp-option-value-2]');
    var sync = function () {
      for (var i = 0; i < labels.length; i++) {
        var k = keyOf(labels[i].textContent);
        if (k) { apply(k); return; }
      }
    };
    if (labels.length) {
      labels.forEach(function (el) {
        new MutationObserver(sync).observe(el, { childList: true, characterData: true, subtree: true });
      });
      sync();
    }
  }

  /* ---------- 2. Zweite Position beim Warenkorb-Klick ---------- */
  var passthrough = false;

  window.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('[data-pdp-form]')) return;

    if (passthrough) { passthrough = false; return; }

    var cb = document.querySelector('[data-smelu-ds-extra]');
    if (!cb || !cb.checked || !cb.value) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    var fired = false;
    var go = function () {
      if (fired) return;
      fired = true;
      passthrough = true;
      if (form.requestSubmit) { form.requestSubmit(); } else { form.submit(); }
    };
    var timer = setTimeout(go, 2500);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(cb.value), quantity: 1 }] })
    })
      .catch(function () {})
      .then(function () { clearTimeout(timer); go(); });
  }, true);
})();
